import React from 'react';
import EnhancedDialog from '../../EnhancedDialog';
import type { WarningState } from '../hooks/useFieldUpdateHandlers';

interface RecordWarningAlertProps {
  warningState: WarningState;
  onConfirm: () => void;
  onCancel: () => void;
}

const RecordWarningAlert: React.FC<RecordWarningAlertProps> = ({
  warningState,
  onConfirm,
  onCancel
}) => {
  return (
    <EnhancedDialog
      isOpen={warningState.isOpen}
      onClose={onCancel}
      title="Warning"
    >
      <div className="sky-dialog-body">
        <div style={{ marginBottom: '10px', fontSize: '14px', fontWeight: 600 }}>
          {warningState.title}
        </div>
        <div>{warningState.message}</div>
      </div>
      <div className="sky-dialog-footer">
        <button className="sky-btn sky-btn-ghost" onClick={onCancel}>
          {warningState.cancelText}
        </button>
        <button className="sky-btn sky-btn-primary" onClick={onConfirm}>
          {warningState.confirmText}
        </button>
      </div>
    </EnhancedDialog>
  );
};

export default RecordWarningAlert;
